import React from 'react'

const Europe2020 = () => {
  return (
    <div>
        Europe2020 - COMING SOON
    </div>
  )
}

export default Europe2020